import { CTAButton } from "@/components/ui/cta-button";

interface HeroActionsProps {
  isPro: boolean;
  onShowWaitlist: () => void;
}

export const HeroActions = ({ isPro, onShowWaitlist }: HeroActionsProps) => {
  return (
    <div className="space-y-8">
      <CTAButton
        variant="secondary"
        onClick={onShowWaitlist}
        mobileText={isPro ? (
          <>
            Premier arrivé,<br />
            premier servi…<br />
            Et SANS commission !
          </>
        ) : undefined}
        desktopText={isPro ? "Devenir un Jedi des réservations 🪐" : "Voir la carte secrète 🗝️"}
      />
      <p className="text-sm text-gray-500">
        {isPro ? "Garanti sans aliens" : "Ne pas partager"}
      </p>
    </div>
  );
};